export default __webpack_public_path__ + "static/media/ATTACCOCARDIACOICONA.e1d2319c.svg";